export class ApplyScheduleModalController {
  constructor($scope, $modalInstance, ServerInformationService) {
    $scope.close = () => {
      $modalInstance.close();
    };
//     $scope.needApplySchedule = ServerInformationService.needApplySchedule;
  }
}



// WEBPACK FOOTER //
// ./src/admin/apply-schedule-modal.component.js